<template>
    <div class="row" style="position: relative;">
        <div style="background-color: white;border-radius: 6px;width: 100%;"
             v-bind:class="{ mainright: showRight }">
            <div class="top-bar">
                <div class="tpl-portlet-title" style="border-bottom: 1px solid rgb(215, 216, 217)">
                    <div class="left">
                        <router-link :to="{ name: 'planmobileinfo', params:{id: plan_id}}"
                                     style="padding: 7px;position: absolute; left: 4%;top: 8px;font-size: 12px;">
                            <i class="el-icon-arrow-left">返回</i>
                        </router-link>
                        <el-button size="mini" style="padding: 7px;position: absolute; right: 4%;top: 8px;"
                                   type="primary"
                                   @click="modify()">保存
                        </el-button>
                    </div>
                </div>
                <div>
                    <div style="border-bottom: 1px solid #d7d8d9">
                        <span style="color:#7e8b9a;margin-right: 10px;">类型</span>
                        <el-select v-model="planType" :disabled=true placeholder="请选择计划类型"
                                   style="width: 85%;text-align: center">
                            <el-option
                                    v-for="item in plan_type_options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div style="border-bottom: 1px solid #d7d8d9">
                        <span style="color:#7e8b9a;margin-right: 10px;">日期</span>
                        <div v-if="planType == 'week'" id="week-plan">
                            <WeekPicker :editable="false" :endDate="endDate" :startDate="startDate"
                                        :weekValue="dateValue"
                                        @fuc="getDate"></WeekPicker>
                        </div>
                        <div v-else-if="planType == 'month'" id="month-plan">
                            <el-date-picker
                                    v-model="dateValue"
                                    :editable="false"
                                    :readonly=true
                                    placeholder="选择月"
                                    style="width: 150px !important;height: 40px;"
                                    type="month"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </div>
                        <div v-else-if="planType == 'quarter'" id="quarter-plan">
                            <QuarterPicker :defaultValue="dateValue" :editable="false" @fuc="getDate"></QuarterPicker>
                        </div>
                        <div v-else-if="planType == 'custom'" id="custom-plan"
                             class="new-custom-plan"
                             style="height: 40px;line-height: 40px;display: inline;">
                            <el-date-picker v-model="startDate"
                                            :clearable="false"
                                            :editable="false"
                                            :picker-options="limitDateStart()"
                                            :readonly=true
                                            placeholder="开始"
                                            size="mini"
                                            style="width: 130px;height: 40px;"
                                            type="date"
                                            value-format="yyyy-MM-dd">
                            </el-date-picker>
                            <span>至</span>
                            <el-date-picker v-model="endDate"
                                            :clearable="false"
                                            :editable="false"
                                            :picker-options="limitDateEnd()"
                                            :readonly=true
                                            placeholder="截止"
                                            size="mini"
                                            style="width: 130px;height: 40px;margin-left: 5px;"
                                            type="date"
                                            value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </div>
                    </div>
                    <div style="border-bottom: 1px solid #d7d8d9">
                        <span style="color:#7e8b9a;">标题</span>
                        <input id="planTitle" v-model="title" class="plan-title" maxlength="45"
                               placeholder="计划标题"
                               style=" height: 40px;width: 85%;margin-left: 15px;line-height: 40px;" type="text"
                               value="">
                    </div>
                    <div style="border-bottom: 1px solid #d7d8d9;position: relative">
                        <span style="color:#7e8b9a;top:10px;position: absolute">内容</span>
                        <textarea v-model="content"
                                  placeholder="主要工作内容"
                                  style="height: 65px;width:85%;padding: 9px;border:none;margin-left: 35px;"></textarea>
                    </div>
                    <div style="border-bottom: 1px solid #d7d8d9;position: relative">
                        <span style="color:#7e8b9a;position: relative;top:10px;">细则
                            <span class="text-blue" @click="addRuleData()">+添加</span></span>
                        <div class="plan-content-wrap" style="margin-top: 20px;">
                            <div class="plan-content">
                                <div class="content-title" style="overflow: hidden">
                                </div>

                                <div style="clear: both;"></div>
                                <div class="plan-detail-box ui-sortable ui-sortable-disabled">
                                    <div class="plan-detail-wrap">
                                        <div v-for='(item,index) in lists' :key="index"
                                             class="plan-detail"
                                             style="position: relative;margin-bottom: 5px;">
                                            <div style="float:left;width: 60%;margin-bottom: 10px;">
                                                <textarea
                                                        v-model="item.content"
                                                        class="planDetail rule-index"
                                                        data-value="item.content"
                                                        placeholder="计划细则"
                                                        style="height: 60px;width: 100%;float: left;padding: 5px;border-radius: 6px;min-height: 60px;"></textarea>
                                            </div>
                                            <div style="float:left;width: 40%;">
                                                <div style="margin: 5px 0">
                                                    <input v-model="item.isImportant" style="margin-left: 11px"
                                                           type="checkbox"/>
                                                    <span style="margin: 0 20% 0 3%;">重要</span>
                                                    <i class="el-icon-delete-solid"
                                                       title="删除该计划细则"
                                                       v-on:click='change_del_state(index)'></i>
                                                </div>
                                                <div style="margin-top: 5px;">
                                                    <el-date-picker v-model="item.rDate"
                                                                    :clearable="false"
                                                                    :editable="false"
                                                                    :picker-options="limitDateStart(item)"
                                                                    class="detailDate"
                                                                    format="MM-dd"
                                                                    placeholder="开始"
                                                                    style="float: left;width: 55px !important;"
                                                                    type="date"
                                                                    value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                    <span style="width: 10%;position:relative;left: 15px;"> ~ </span>
                                                    <el-date-picker v-model="item.eDate"
                                                                    :clearable="false"
                                                                    :editable="false"
                                                                    :picker-options="limitDateEnd(item)"
                                                                    class="detailDate detail-end-Date"
                                                                    format="MM-dd"
                                                                    placeholder="截止"
                                                                    style="position: relative;left: 15px;width: 40px !important;"
                                                                    type="date"
                                                                    value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                </div>
                                            </div>
                                            <div style="clear: both;"></div>
                                        </div>
                                    </div>
                                    <div v-if="otherList.length > 0" class="plan-detail-wrap" style="margin-top: 5px;">
                                        <p style="font-weight: bold"><i class="fa fa-tasks"></i> 其他细则 <span
                                                style="font-weight: bold;">{{ otherList.length }}</span></p>
                                        <div v-for='(item,index) in otherList' :key="index"
                                             class="plan-detail"
                                             style="position: relative;margin-bottom: 5px;">
                                            <div style="float:left;width: 60%;margin-bottom: 10px;">
                                                <textarea
                                                        v-model="item.content"
                                                        class="planDetail rule-index"
                                                        data-value="item.content"
                                                        placeholder="计划细则"
                                                        style="height: 60px;width: 100%;float: left;padding: 5px;border-radius: 6px;min-height: 60px;"></textarea>
                                            </div>
                                            <div style="float:left;width: 40%;">
                                                <div style="margin: 5px 0">
                                                    <input v-model="item.isImportant" style="margin-left: 11px"
                                                           type="checkbox"/>
                                                    <span style="margin: 0 20% 0 3%;">重要</span>
                                                </div>
                                                <div style="margin-top: 5px;">
                                                    <el-date-picker v-model="item.rDate"
                                                                    :clearable="false"
                                                                    :editable="false"
                                                                    :picker-options="limitDateStart(item)"
                                                                    class="detailDate"
                                                                    format="MM-dd"
                                                                    placeholder="开始"
                                                                    style="float: left;width: 55px !important;"
                                                                    type="date"
                                                                    value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                    <span style="width: 10%;position:relative;left: 15px;"> ~ </span>
                                                    <el-date-picker v-model="item.eDate"
                                                                    :clearable="false"
                                                                    :editable="false"
                                                                    :picker-options="limitDateEnd(item)"
                                                                    class="detailDate detail-end-Date"
                                                                    format="MM-dd"
                                                                    placeholder="截止"
                                                                    style="position: relative;left: 15px;width: 40px !important;"
                                                                    type="date"
                                                                    value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                </div>
                                            </div>
                                            <div style="clear: both;"></div>
                                        </div>
                                    </div>
                                </div>
                                             <div style="clear: both;"></div>
                            </div>
                        </div>
                        <div class="add-category" style="display: none;"><i class="icon-add-category"></i><span>+继续添加计划内容</span>
                        </div>
                    </div>
                </div>
                <div>
                    <div v-if="recycleList.length > 0">
                        <span style="color:#7e8b9a;position: relative;top:10px;">已删细则</span>
                        <div class="plan-content-wrap" style="margin-top: 20px;">
                            <div class="plan-content">
                                <div class="content-title" style="overflow: hidden">
                                </div>
                                <p class="remark_r content-tip"></p>
                                <div class="plan-detail-box ui-sortable ui-sortable-disabled">
                                    <div class="plan-detail-wrap">
                                        <div v-for='(item,index) in recycleList' :key="index"
                                             class="plan-detail"
                                             style="position: relative;margin-bottom: 5px;">
                                            <div style="float:left;width: 60%;margin-bottom: 10px;">
                                                <textarea
                                                        v-model="item.content"
                                                        :disabled="true"
                                                        class="planDetail rule-index"
                                                        data-value="item.content"
                                                        placeholder="计划细则"
                                                        style="height: 60px;width: 100%;float: left;padding: 5px;border-radius: 6px;min-height: 60px;"></textarea>
                                            </div>
                                            <div style="float:left;width: 40%;">
                                                <div style="margin: 5px 0">
                                                    <input v-model="item.isImportant" :disabled="true"
                                                           style="margin-left: 11px"
                                                           type="checkbox"/>
                                                    <span style="margin-left: 11px;">重要</span>
                                                    <i class="el-icon-delete-solid" style="margin: 0 10%"
                                                       title="删除该计划细则"
                                                       v-on:click='del_true_dateail(index)'></i>
                                                    <i class="el-icon-refresh-left " title="恢复该计划细则"
                                                       v-on:click='recovery_del_state(index)'></i>
                                                </div>
                                                <div style="margin-top: 5px;">
                                                    <el-date-picker v-model="item.rDate"
                                                                    :clearable="false"
                                                                    :disabled="true"
                                                                    :editable="false"
                                                                    :picker-options="limitDateStart(item)"
                                                                    class="detailDate"
                                                                    format="MM-dd"
                                                                    placeholder="开始日期"
                                                                    style="float: left;width: 55px !important;"
                                                                    type="date"
                                                                    value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                    <span style="width: 10%;position:relative;left: 15px;"> ~ </span>
                                                    <el-date-picker v-model="item.eDate"
                                                                    :clearable="false"
                                                                    :disabled="true"
                                                                    :editable="false"
                                                                    :picker-options="limitDateEnd(item)"
                                                                    class="detailDate detail-end-Date"
                                                                    format="MM-dd"
                                                                    placeholder="截止日期"
                                                                    style="position: relative;left: 15px;width: 40px !important;"
                                                                    type="date"
                                                                    value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                </div>
                                            </div>
                                            <div style="clear: both;"></div>
                                        </div>
                                    </div>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QuarterPicker from '@/components/common_components/datepicker/quarter_picker.vue'
import WeekPicker from '@/components/common_components/datepicker/week_picker.vue'
import planApi from '@/api/plan/plan_api.js'
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
    name: "edit_plan",
    data: function () {
        return {
            showRight: false,
            quarterArray: ["01", "04", "07", "10"],
            quarterArray2: [1, 4, 7, 10],
            title: '',
            content: '',
            summary: '',
            planType: '',
            layout: 'month',
            dateValue: this.$route.params.dateValue,
            startDate: this.$route.params.startDate,
            endDate: this.$route.params.endDate,
            value1: '',
            plan_id: 0,
            weekIdex: 0,
            details_info: [],
            lists: [{
                idx: 1,
                id: 0,
                plan_id: true,
                content: '',
                rDate: '',
                eDate: '',
                isImportant: false,
                isEmergency: false,
                isDelete: false
            }],
            recycleList: [],
            deleteList: [],
            otherList: [],
            nextTodoId: 2,
            plan_type_options: [{
                value: 'week',
                label: '周计划'
            }, {
                value: 'month',
                label: '月计划'
            }, {
                value: 'quarter',
                label: '季计划'
            }, {
                value: 'custom',
                label: '自定义'
            }],
        }
    },
    computed: {
        ...mapState({
            login_user_id: state => state.loginState.user_info.id,
            // plan_info: state => state.plan.plan_information,
            // active_plan_id: state => state.plan.active_plan_id,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({
            get_plan_info: 'plan/get_plan_info',
            change_warning_message: 'warningBar/change_message',
            change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class'
        }),
        getDate: function (val, val2) {
            this.dateValue = val;
            this.startDate = val;
            this.endDate = val2;
        },
        getValue: function () {
            this.layout = this.planType
        },
        autoSelectDate: function () {
            let tempStartDate = '';
            let tempEndDate = '';
            if (this.planType == 'week' || this.planType == 'custom') {
                tempStartDate = this.startDate;
                tempEndDate = this.endDate;
            } else if (this.planType == 'month') {
                const currDate = new Date(this.startDate);
                const year = currDate.getFullYear();
                const month = currDate.getMonth() + 1;
                tempStartDate = year + '-' + month + '-1';
                tempEndDate = year + '-' + month + '-' + new Date(year, month, 0).getDate();
            } else if (this.planType == 'quarter') {
                const eDateArray = this.dateValue.replace(/\//g, '-').split('-');
                const month = parseInt(eDateArray[1]) + 2;
                tempStartDate = eDateArray[0] + '-' + eDateArray[1] + '-1';
                tempEndDate = eDateArray[0] + '-' + month + '-' + new Date(eDateArray[0], month, 0).getDate();
            }
            if (tempStartDate && tempStartDate != 'undefined') tempStartDate = tempStartDate.replace(/\//g, '-');
            if (tempEndDate && tempEndDate != 'undefined') tempEndDate = tempEndDate.replace(/\//g, '-');
            else tempEndDate = '';
            return [tempStartDate, tempEndDate];
        },
        addRule: function (date) {
            this.lists.push({
                idx: this.nextTodoId++,
                id: 0,
                plan_id: true,
                content: '',
                rDate: date[0].toString().replace(/\//g, '-'),
                eDate: date[1].toString().replace(/\//g, '-'),
                isImportant: false,
                isEmergency: false,
                isDelete: false,
            })
        },
        addRuleData: function () {
            const autoDate = this.autoSelectDate();
            this.addRule(autoDate);
        },
        addDays: function (d, planType) {
            let date = new Date(d);
            return planType === 'month' ? (date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (new Date(date.getFullYear(), date.getMonth() + 1, 0)).getDate()) : date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate() + 5);
        },
        showPreviewPlan() {
            this.showRight = true;
        },
        clickClose() {
            this.showRight = false;
        },
        limitDateStart: function (detail) {
            let other_date = this.endDate;
            if (detail != null) other_date = detail.eDate;
            return {
                disabledDate(time) {
                    return time.getTime() > new Date(other_date).getTime();
                }
            }
        },
        limitDateEnd: function (detail) {
            let other_date = this.startDate;
            if (detail != null) other_date = detail.rDate
            return {
                disabledDate(time) {
                    return time.getTime() < new Date(other_date).getTime();
                }
            }
        },
        change_del_state(index) {
            let currData = this.lists[index];
            this.lists.splice(index, 1);
            currData.isDelete = true;
            this.recycleList.push(currData);
        },
        recovery_del_state(index) {
            let currData = this.recycleList[index];
            this.recycleList.splice(index, 1);
            currData.isDelete = false;
            this.lists.push(currData);
        },
        del_true_dateail(index) {
            let currData = this.recycleList[index];
            this.recycleList.splice(index, 1);
            currData.isDelete = "del_true";
            this.deleteList.push(currData);
        },
        modify: async function () {
            let saveMsg = ''
            let result = 'success'
            if (!this.title.trim()) {
                saveMsg = '标题不能为空'
                result = 'error'
            } else {
                if (this.planType == 'month') {
                    let arr = this.dateValue.split("-");
                    this.startDate = arr[0] + '-' + arr[1] + '-01';
                    this.endDate = this.addDays(this.startDate, 'month');
                }
                this.startDate = this.startDate.replace('/', '-').replace('/', '-')
                this.endDate = this.endDate.replace('/', '-').replace('/', '-')

                let res = await planApi.modify_plan({
                    plan_id: this.plan_id,
                    title: this.title,
                    content: this.content,
                    planType: this.planType,
                    openTime: this.startDate,
                    endTime: this.endDate,
                    lists: [].concat(this.lists).concat(this.recycleList),
                    deleteList: this.deleteList,
                })
                let data = JSON.parse(res.data.result);
                result = data.code
                saveMsg = data.message
            }
            this.change_warning_message(saveMsg);
            if (result === 'success') {
                this.change_warning_bar_style_class('success');
                await this.$router.push({name: 'planmobileinfo', params: {id: this.plan_id.toString()}});
            } else {
                this.change_warning_bar_style_class('alert');
            }
        },
        getWeek: function (z) {
            let day11 = new Date(z);
            day11.setMonth(0);
            day11.setDate(1);
            day11.setHours(0);
            day11.setMinutes(0);
            day11.setSeconds(0);//到这里就得到该年的一月一日
            let day11mill = day11.getTime();
            let ori_day = day11.getDay();//该年的一月一日是星期几
            let fill1 = 0;//与星期日相隔的毫秒数
            if (ori_day !== 0) {
                fill1 = ori_day * 60 * 60 * 24 * 1000;
            }

            let now = Date.parse(z);
            now = new Date(now);
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            let nowmill = now.getTime();
            let now_day = now.getDay();
            let fill2 = 0;
            if (now_day !== 0) {
                fill2 = (7 - now_day) * 60 * 60 * 24 * 1000;
            }

            let cha2 = (nowmill - day11mill + fill1 + fill2) / (60 * 60 * 24 * 1000);
            let week = Math.ceil(cha2 / 7);
            if (week < 10) {
                week = "0" + week;
            }
            return week;
        }
    },
    components: {
        QuarterPicker,
        WeekPicker,
    },
    async mounted() {
        let planId = this.$route.params.id
        if (typeof (planId) != "undefined") {
            let planInfo = (await planApi.get_plan_info(planId)).data;
            if (planInfo.creator === this.login_user_id) {
                this.title = planInfo.title;
                localStorage.setItem('edit_post_content', planInfo.title)
                this.plan_id = planInfo.id;
                this.planType = planInfo.plan_type;
                this.dateValue = planInfo.open_time;
                this.startDate = planInfo.open_time;
                this.endDate = planInfo.end_time;
                this.content = planInfo.content;
                this.summary = planInfo.summary;

                let args = {
                'planid': planInfo.id,
                'uid': planInfo.creator,
                    'sdate': this.startDate,
                    'edate': this.endDate,
                    'ptype': this.planType,
                }
                let d = await planApi.get_my_todos_by_date(args);
                let curr_details = d.data.filter(x => x.plan_id === planInfo.id);
                let other_details = d.data.filter(x => x.plan_id !== planInfo.id);
                this.details_info = [].concat(curr_details.sort((a, b) => a.id - b.id))
                    .concat(other_details.sort(function (a, b) {
                        if (a.plan_id === b.plan_id) return a.id - b.id;
                        else return a.plan_id - b.plan_id;
                    }));
                this.lists = [];
                this.details_info.forEach((item) => {
                    let currData = {
                        id: item.id,
                        plan_id: item.plan_id,
                        content: item.details,
                        rDate: item.start_time,
                        eDate: item.end_time,
                        isImportant: item.isImportant,
                        isEmergency: item.isEmergency,
                        isDelete: item.isDelete,
                    };
                    if (item.plan_id !== planId && !item.isDelete) this.otherList.push(currData)
                    else if (item.isDelete) this.recycleList.push(currData);
                    else this.lists.push(currData);
                })
            } else {
                this.change_warning_bar_style_class('alert');
                await this.$router.go(-1);
            }
        } else {
            this.change_warning_bar_style_class('alert');
            await this.$router.go(-1);
        }
    }
}
</script>

<style scoped>
.top-bar {
    position: relative;
    padding: 5px 20px;
    overflow: hidden;
}

[class^="icon-"] {
    background-image: url(/static/img/plan.png?v=6);
    background-image: -webkit-image-set(url(/static/img/plan.png?v=6) 1x, url(/static/img/plan@2x.png?v=6) 2x);
    background-image: image-set(url(/static/img/plan.png?v=6) 1x, url(/static/img/plan@2x.png?v=6) 2x);
    vertical-align: middle;
    display: inline-block;
    background-repeat: no-repeat;
}

.new-main {
    padding-left: 24px;
    overflow: auto;
    z-index: -1 \0;
}


.new-main table {
    border-collapse: separate;
    border-spacing: 0 16px;
}

.must-fill {
    font-style: normal;
    color: #f00;
}

.new-main table td.even {
    padding-left: 4px;
}

.new-main table td input[type='text'] {
    width: 90%;
    height: 30px;
    border-radius: 3px;
    padding-left: 8px;
    border: 1px solid #d7d8d9;
}

.new-main table td .other-plan {
    margin-left: 13px;
}

.new-main table td .title-tip {
    position: absolute;
}

.remark_r {
    color: #F00;
}

.new-main table .v-top {
    vertical-align: top;
    text-align: right;
}

.new-main table td .mar-top16 {
    margin-top: 16px;
}

.new-main table .v-top span {
    display: inline-block;
}

.new-main table td .plan-content-wrap {
    border: 1px solid transparent;
}

.new-main table td .plan-content {
    position: relative;
    width: 90%;
    padding: 9px;
    background-color: #f8f8f8;
    margin-bottom: 24px;
    transition: border-color .3s;
    border: 1px solid transparent;
    margin-right: 20px;
}

.new-main table td .plan-content input[type='text'] {
    width: 90%;
}

.new-main table td .content-tip {
    line-height: 24px;
    height: 16px;
}

.new-main table td .plan-content .plan-detail-box {
    padding: 0;
    margin: -20px 0;
}

.new-main table td .plan-content .plan-detail {
    position: relative;
    overflow: hidden;
}

.new-main table td .plan-content textarea {
    resize: none;
    width: 40%;
    min-height: 60px;
    padding-right: 20px;
    border-radius: 0;
    border: 1px solid #d7d8d9;
    margin-bottom: 16px;
    overflow: hidden;
}

.fa-recovery {
    position: relative;
    left: 16px;
    top: 8px;
    font-size: 14px;
}

.icon-remove {
    position: relative;
    top: 8px;
    left: 6px;
    font-size: 14px;
}

.new-main table td .remove {
    font-size: 18px;
    position: relative;
    text-shadow: none;
    top: 1px;
    margin-left: 1px;
    margin-right: 16px;
    color: #a7bdcd;
    font-style: normal;
    font-family: "Font Awesome 5 Pro";
    font-weight: 900;
}

.new-main table td .sec-remove {
    position: absolute;
    top: 2px;
    right: 10px;
    background-color: transparent;
    margin: 0;
}

.new-main table td .plan-content .add-detail {
    cursor: pointer;
    margin-left: 20px;
    margin-top: 15px;
}

.icon-add-detail {
    font-style: normal;
    width: 9px;
    height: 9px;
    color: #2299ee;
    background-position: -87px -36px;
}


.new-main table td .plan-content i {
    cursor: pointer;
}

.new-main table td .plan-content .add-detail i {
    vertical-align: 0px;
    margin-right: 4px;
}

.text-blue {
    color: #2299ee;
}

.text-gray {
    color: #ccc;
}

.add-detail span {
    margin-right: 10px;
}

.add-category {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #f8f8f8;
    color: #2299ee;
    cursor: pointer;
    width: 700px;
}

.icon-add-category {
    font-style: normal;
    background-position: -32px -32px;
    width: 18px;
    height: 18px;
}

.new-main table td .add-category i {
    vertical-align: middle \0;
    margin-right: 8px;
}

.new-main table .v-top {
    vertical-align: top;
    text-align: right;
}

.padding-top-a8 {
    padding-top: 8px;
}

.new-main table td .plan-conclusion {
    width: 689px;
    resize: none;
    border-radius: initial;
}

.btn-group {
    position: relative;
    display: inline-block;
    *display: inline;
    *zoom: 1;
    vertical-align: middle;
    white-space: nowrap;
    *margin-left: .3em;
}

.btn-group button {
    height: 30px;
    margin-right: 10px;
    border-style: none;
    font-size: 12px;
    border-radius: 3px
}

.btn-group button.release {
    width: 120px;
    background-color: #2299ee;
    color: #fff;
}

.btn-group button.cancel {
    width: 90px;
    background-color: #fff;
    border: 1px solid #d7d8d9;
    color: #000;
}

.mask-span {
    width: 120px;
    display: inline-block;

    height: 26px;
    padding: 0 0;
    line-height: 26px;
    padding-left: 10px;
    background-color: transparent;
    border: 1px solid #d7d8d9;
    border-radius: 0;
    color: #666;
    cursor: pointer;
    margin-right: 10px;
    margin-left: 0;
    position: relative;
    z-index: 19;
}

.mask-span.week {
    width: 160px;
}

#week-plan, #month-plan, #quarter-plan {
    line-height: 24px;
    display: inline-block;
    vertical-align: middle;
}

.icon-triangle-up, .icon-triangle-right, .icon-triangle-down, .icon-triangle-left {
    background-image: none;
    width: 0;
    height: 0;
    cursor: pointer;
}

.icon-triangle-down {
    border-left: 5px solid transparent;
    border-top: 5px solid #9a9a9a;
    border-right: 5px solid transparent;
    vertical-align: middle;
    display: inline-block;
}

* {
    margin: 0;
    padding: 0;
    list-style: none;

}

.head {
    padding: 20px;
}

.navBar input {
    width: 215px;
    height: 38px;
    display: inline-block;
}

.show1 {
    width: 320px;
    margin-top: 5px;
    position: absolute;
    z-index: 2;

    height: 160px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    background: #fff;
    padding: 5px;
}

.show1 p:nth-child(1) {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #f5f5f5;
}

.show1 p:nth-child(2) {
    box-sizing: border-box;
}

.selectMonth {
    display: inline-block;
    float: left;
    width: 78px;
    height: 40px;
    line-height: 40px;
    text-align: center;
}

.selectMonth:hover {
    background: rgba(19, 131, 255, 0.052);
}

.span-year {
    width: 90%;
    margin: 0 auto;
    display: inline-block;
    text-align: center;
    line-height: 40px;

}

.el-input {
    width: 215px;
    height: 45px;
    display: inline-block;
}

.new-main table td .other-plan {
    margin-left: 13px;
    font-size: 12px;
}

.new-main table td .other-plan a.look-prev {
    border-right: 1px solid #d9d9d9;
    display: inline-block;
    line-height: 12px;
    padding-right: 8px;
    margin-right: 7px;
}

.new-main table td .other-plan a {
    color: #29e;
}

.mainright {
    margin-right: 522px
}

</style>
<style>
.el-select .el-input__inner {
    font-size: 11px !important;
}

.el-select-dropdown__item {
    text-align: center;
}

.detailDate .el-input__icon {
    height: 28px;
    line-height: 28px;
}

.detail-end-Date .el-input__icon {
    display: none;
}

.detail-end-Date .el-input__inner {
    margin-left: 0 !important;
    width: 40px !important;
}

.detailDate .el-input__inner {
    height: 28px;
    line-height: 28px;
    width: 80px;
    font-size: 12px;
    padding-right: 0px !important;
    margin-left: 8px;
}

.detailDate.el-input {
    height: 28px;
    line-height: 28px;
}

#custom-plan .el-input--suffix .el-input__inner {
    padding-right: 0 !important;
}

.plan-detail .el-input--suffix .el-input__inner {
    padding-right: 0 !important;
    padding-left: 0 !important;
}

.el-date-editor--daterange.el-input__inner {
    width: 200px !important;
}

.el-date-editor .el-range-input {
    width: 22% !important;
    font-size: 12px !important;
}

.el-date-editor .el-range-separator {
    width: 11% !important;
}

.el-input__inner {
    border: none;
    text-align: center;
}
</style>